import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider, createRouter } from '@tanstack/react-router'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { UpdatePrompt } from './components/pwa/update-prompt'
import { ToastProvider } from './components/ui/toast'
import { PWAProvider } from './contexts/pwa-context'
import { queryClient } from './lib/query-client'
import { routeTree } from './routeTree.gen'

import './styles/globals.css'

// 创建路由实例
const router = createRouter({ routeTree })

// 类型声明
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

// 渲染应用
const rootElement = document.getElementById('root')

if (rootElement) {
  createRoot(rootElement).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <ToastProvider>
          <PWAProvider>
            <RouterProvider router={router} />
            <UpdatePrompt />
          </PWAProvider>
        </ToastProvider>
      </QueryClientProvider>
    </StrictMode>
  )
}
